<div class="flex flex-col gap-6 py-4">
  <!-- Bien en copropriété & Nombre de lots (données BDNB) -->
  <div class="flex flex-col gap-3 rounded-2xl border border-neutral-3 bg-neutral-2/40 p-5">
    <div class="flex items-center justify-between">
      <div class="flex flex-col gap-0.5">
        <span class="text-sm font-medium text-neutral-12">Bien en copropriété</span>
        <span class="text-xs text-neutral-10"
          >Renseigné automatiquement via le registre national des bâtiments (BDNB)</span
        >
      </div>
      <div>
        @if (model().isInCoOwnership === true) {
          <span
            class="inline-flex items-center gap-1.5 rounded-full border border-emerald-5 bg-emerald-2 px-3 py-1 text-xs font-semibold text-emerald-11"
          >
            <mat-icon class="!h-4 !w-4 !text-base leading-none text-emerald-10">check_circle</mat-icon>
            Oui
          </span>
        } @else if (model().isInCoOwnership === false) {
          <span
            class="inline-flex items-center gap-1.5 rounded-full border border-neutral-5 bg-neutral-3 px-3 py-1 text-xs font-semibold text-neutral-11"
          >
            <mat-icon class="!h-4 !w-4 !text-base leading-none text-neutral-10">cancel</mat-icon>
            Non
          </span>
        } @else {
          <span class="text-xs italic text-neutral-10">Non renseigné</span>
        }
      </div>
    </div>

    @if (model().isInCoOwnership === true) {
      <div class="flex items-center justify-between border-t border-neutral-3 pt-3">
        <div class="flex flex-col gap-0.5">
          <span class="text-sm font-medium text-neutral-11">Nombre de lots de la copropriété</span>
          <span class="text-xs text-neutral-9">Nombre total de lots déclarés au registre</span>
        </div>
        @if (model().numberOfLots) {
          <span
            class="inline-flex items-center rounded-lg border border-neutral-4 bg-white px-3 py-1 text-sm font-semibold text-neutral-12 shadow-xs dark:bg-neutral-3"
          >
            {{ model().numberOfLots }} {{ model().numberOfLots! > 1 ? 'lots' : 'lot' }}
          </span>
        } @else {
          <span class="text-xs italic text-neutral-10">Non renseigné</span>
        }
      </div>
    }
  </div>

  @if (model().isInCoOwnership === true) {
    <div class="flex flex-col gap-6 animate-in fade-in duration-300 slide-in-from-top-2">
      <!-- Lot Number -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Numéro de lot de votre habitation</mat-label>
        <input matInput [formField]="formTree.lotNumber" placeholder="Ex: 12" />
      </mat-form-field>

      <div class="flex flex-col gap-4 md:flex-row md:items-center">
        <!-- Trustee info -->
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Nom du syndic</mat-label>
          <input matInput [formField]="formTree.trustee.name" />
        </mat-form-field>

        <div class="flex items-center">
          <mat-checkbox [formField]="formTree.trustee.isOnline" color="primary">
            Syndic en ligne
          </mat-checkbox>
        </div>
      </div>

      <!-- Procedures toggle -->
      <div class="flex items-center">
        <mat-checkbox [formField]="formTree.trustee.hasOngoingProcedures" color="primary">
          Procédures en cours contre syndic/copropriété
        </mat-checkbox>
      </div>

      <!-- Procedures list -->
      @if (model().trustee.hasOngoingProcedures) {
        <div class="border-warning-3/20 bg-warning-2/10 rounded-xl border p-4">
          <p class="text-warning-9 mb-3 text-sm font-medium">Veuillez préciser le type de procédure :</p>
          <mat-selection-list [formField]="formTree.trustee.ongoingProcedures" color="warn" class="w-full">
            @for (type of procedureTypes; track type) {
              <mat-list-option
                [value]="type"
                checkboxPosition="before"
                class="hover:bg-warning-3/10 rounded-lg transition-colors"
              >
                {{ type | etxeEnumDisplay: 'coOwnershipProcedureType' }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      }
    </div>
  }
</div>
